import React from "react";
import TableData from "./Table/TableData";
export default function GoodsInCard() {
  return (
    <div>
      <div class="flex flex-wrap justify-center">
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
            <TableData />
          </div>
      </div>
    </div>
  );
}
